/* tslint:disable */
/* eslint-disable */
/**
 * Activity Feed API
 * API for managing activity feed entries including historical events, actions, and notifications.  The activity feed provides a unified timeline of events and actions for insured risks (risques assurés). It supports notifications with read/unread status tracking and badge count for UI display.  ## Entry Types - **Historique**: Historical events (e.g., mandate signed, document uploaded) - **Action**: Actionable items with due dates (e.g., pending approvals, required follow-ups)  ## Sources - **Internal**: Events generated by the platform - **External**: Events from external systems or user actions  ## Entity Links Messages can contain entity references in the format `{EntityType:Guid}` which are resolved using the `entities` array for navigation purposes. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SortingFieldEnum } from './SortingFieldEnum';
import {
    SortingFieldEnumFromJSON,
    SortingFieldEnumFromJSONTyped,
    SortingFieldEnumToJSON,
    SortingFieldEnumToJSONTyped,
} from './SortingFieldEnum';
import type { FiltersDto } from './FiltersDto';
import {
    FiltersDtoFromJSON,
    FiltersDtoFromJSONTyped,
    FiltersDtoToJSON,
    FiltersDtoToJSONTyped,
} from './FiltersDto';

/**
 * 
 * @export
 * @interface GetGenericListCommandDto
 */
export interface GetGenericListCommandDto {
    /**
     * Search string for filtering results (maximum 100 characters)
     * @type {string}
     * @memberof GetGenericListCommandDto
     */
    searchString?: string;
    /**
     * Page number for pagination (must be greater than 0)
     * @type {number}
     * @memberof GetGenericListCommandDto
     */
    pageNumber: number;
    /**
     * Number of items per page (between 1 and 100)
     * @type {number}
     * @memberof GetGenericListCommandDto
     */
    pageSize: number;
    /**
     * Legacy (numérique), ignoré dès que sortBy est renseigné — ne plus utiliser.
     * @type {SortingFieldEnum}
     * @memberof GetGenericListCommandDto
     * @deprecated
     */
    sorting?: SortingFieldEnum;
    /**
     * Clé de tri de colonne : date (défaut) | status | identifier | insured | branch | product (code) | productLabel (nom) | tunnel (colonne tunnelLabel) | clientPrice | effectiveDate | endDate | mainDueDate (contrats, tri chronologique jj/MM) | broker | plateforme. Disponibilité selon la liste (product/productLabel/tunnel/ effectiveDate/endDate indisponibles sur simulations ; mainDueDate contrats uniquement ; broker/plateforme réservés aux routes admin, plateforme absent des simulations). Omis ou inconnu -> tri par défaut (dernière modification, décroissant).
     * 
     * @type {string}
     * @memberof GetGenericListCommandDto
     */
    sortBy?: string;
    /**
     * "asc" ou "desc" (défaut : desc)
     * @type {string}
     * @memberof GetGenericListCommandDto
     */
    sortDirection?: string;
    /**
     * 
     * @type {FiltersDto}
     * @memberof GetGenericListCommandDto
     */
    filters?: FiltersDto;
}



/**
 * Check if a given object implements the GetGenericListCommandDto interface.
 */
export function instanceOfGetGenericListCommandDto(value: object): value is GetGenericListCommandDto {
    if (!('pageNumber' in value) || value['pageNumber'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    return true;
}

export function GetGenericListCommandDtoFromJSON(json: any): GetGenericListCommandDto {
    return GetGenericListCommandDtoFromJSONTyped(json, false);
}

export function GetGenericListCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGenericListCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'searchString': json['searchString'] == null ? undefined : json['searchString'],
        'pageNumber': json['pageNumber'],
        'pageSize': json['pageSize'],
        'sorting': json['sorting'] == null ? undefined : SortingFieldEnumFromJSON(json['sorting']),
        'sortBy': json['sortBy'] == null ? undefined : json['sortBy'],
        'sortDirection': json['sortDirection'] == null ? undefined : json['sortDirection'],
        'filters': json['filters'] == null ? undefined : FiltersDtoFromJSON(json['filters']),
    };
}

export function GetGenericListCommandDtoToJSON(json: any): GetGenericListCommandDto {
    return GetGenericListCommandDtoToJSONTyped(json, false);
}

export function GetGenericListCommandDtoToJSONTyped(value?: GetGenericListCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'searchString': value['searchString'],
        'pageNumber': value['pageNumber'],
        'pageSize': value['pageSize'],
        'sorting': SortingFieldEnumToJSON(value['sorting']),
        'sortBy': value['sortBy'],
        'sortDirection': value['sortDirection'],
        'filters': FiltersDtoToJSON(value['filters']),
    };
}

